import React from "react";
import { stylerDecimalPart } from "../../../../utils/stylerDecimalPart";

export default function WarningPrice(props) {
  // PROPS COMING FROM useFreeGoodsAllocation
  const {
    setShowDetails,
    setElementId,
    vatExcludedPrice,
    freeGoodsAllocationActive,
    orderNumber,
  } = props;

  return (
    <p className="fs1">
      Ürün fiyatı, tanımlı mal fazlası tutarını aştığı için ürün eklenemiyor.{" "}
      <span
        onClick={() => {
          return [
            setShowDetails(
              <table className="w100p fs1 dark-grey">
                <thead>
                  <tr>
                    <th colSpan={4} className="txtcenter slightlyyellowbck">
                      {orderNumber} Numaralı Sipariş İçin
                    </th>
                    <td></td>
                  </tr>
                  <tr>
                    <th className="w70p">Ürün Fiyatı</th>
                    <td className="txtleft w30p">
                      {parseInt(vatExcludedPrice)}.
                      {stylerDecimalPart(vatExcludedPrice)} TL
                    </td>
                  </tr>
                  <tr>
                    <th className="w70p">Mal Fazlası Tutarı</th>
                    <td className="txtleft w30p">
                      {parseInt(freeGoodsAllocationActive)}.
                      {stylerDecimalPart(freeGoodsAllocationActive)} TL
                    </td>
                  </tr>
                  <tr>
                    <th colSpan={4} className="txtcenter slightlyyellowbck">
                      Mal Fazlası Tutarı Yetersiz
                    </th>
                    <td></td>
                  </tr>
                  <tr id="scroll-element">
                    <th colSpan={4} className="padq txtleft greenbcklight">
                      Harcanamayan tutarlar nakit olarak alınmaz ya da indirim
                      olarak yansıtılmaz. Ancak, bir sonraki siparişinize
                      aktarılır.
                    </th>
                    <td></td>
                  </tr>
                </thead>
              </table>
            ),
            setElementId("scroll-element"),
          ];
        }}
        className="linkblue"
      >
        Detay Gör
      </span>
    </p>
  );
}
